import { useState } from "react";
import { capitalizeText } from "../../Utils/Common";
import BtnSave from "../Commons/Buttons/BtnSave";
import { formatDate } from "../Helpers/Utilities/Common";
import { AddPhilHealthForm } from "./AddPhilHealthForm";
import { Row, Col } from "antd";

export function PhilHealthMedicalRecord({ patientDetails }) {
  return patientDetails?.phic_membership_type !== null ? (
    <RecordDetails philhealthData={patientDetails} />
  ) : (
    <AddPhilHealthForm patientDetails={patientDetails} />
  );
}

function RecordDetails({ philhealthData }) {
  const [isEditing, setIsEditing] = useState(false);
  const {
    phic_membership_type,
    phic_pin,
    phic_dependent_pin,
    phic_birthdate,
    contact_no,
    phic_enlistment_date,
    phic_enlistment_status,
    phic_package_type,
    phic_atc,
    formatted_patient_name,
    birthdate,
    phone_no,
  } = philhealthData;

  if (isEditing) {
    return (
      <AddPhilHealthForm
        patientDetails={philhealthData}
        isEditing={true}
        onCancel={() => setIsEditing(false)}
      />
    );
  }

  return (
    <div>
      <h5 className="font-bold mb-3">MEDICAL RECORD</h5>

      {/* Example of consistent layout */}
      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Membership Type</strong>
        </Col>
        <Col span={16} className="text-left">
          {capitalizeText(phic_membership_type)}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>PhilHealth Identification Number (PIN)</strong>
        </Col>
        <Col span={16} className="text-left">
          {phic_pin}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Name</strong>
        </Col>
        <Col span={16} className="text-left">
          {formatted_patient_name}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Birthdate</strong>
        </Col>
        <Col span={16} className="text-left">
          {formatDate(phic_birthdate)}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Mobile Number</strong>
        </Col>
        <Col span={16} className="text-left">
          {contact_no}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Enlistment Date</strong>
        </Col>
        <Col span={16} className="text-left">
          {formatDate(phic_enlistment_date)}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Enlistment Status</strong>
        </Col>
        <Col span={16} className="text-left">
          {capitalizeText(phic_enlistment_status)}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Package Type</strong>
        </Col>
        <Col span={16} className="text-left">
          {phic_package_type}
        </Col>
      </Row>

      <Row className="mb-2">
        <Col span={8} className="text-left">
          <strong>Authorization Transaction Code (ATC)</strong>
        </Col>
        <Col span={16} className="text-left">
          {phic_atc}
        </Col>
      </Row>

      <Row className="d-flex justify-content-end">
        <Col xs={6}>
          <BtnSave
            label={"Edit Philhealth"}
            size={"sm"}
            onClick={() => setIsEditing(true)}
          />
        </Col>
      </Row>

      {/* Dependent Information */}
      {philhealthData?.phic_membership_type === "dependent" && (
        <>
          <h6 className="mt-4 mb-2">Dependent Information</h6>

          <Row className="mb-2">
            <Col span={8} className="text-left">
              <strong>PhilHealth Identification Number (PIN)</strong>
            </Col>
            <Col span={16} className="text-left">
              {phic_dependent_pin}
            </Col>
          </Row>

          <Row className="mb-2">
            <Col span={8} className="text-left">
              <strong>Name</strong>
            </Col>
            <Col span={16} className="text-left">
              {formatted_patient_name}
            </Col>
          </Row>

          <Row className="mb-2">
            <Col span={8} className="text-left">
              <strong>Birthdate</strong>
            </Col>
            <Col span={16} className="text-left">
              {formatDate(birthdate)}
            </Col>
          </Row>

          <Row className="mb-2">
            <Col span={8} className="text-left">
              <strong>Phone Number</strong>
            </Col>
            <Col span={16} className="text-left">
              {phone_no}
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}
